// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
	},
};

(function() {

	BoostPFS.inject(this);
	/************************** BUILD PRODUCT LIST **************************/

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;

		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		var gridMobileClass = '',
			gridItemWidthClass = '',
			itemGridDetailStyleClass = '',
			itemSoldOutClass = '',
			itemSaleClass = '',
			itemGridImageSizeClass = boostPFSTemplate.gridImageSizeHtml,
			itemGridAlignClass = '',
			itemLabels = '',
			itemGridSecondHoverClass = '',
			itemRatio = boostPFSTemplate.itemRatioHtml,
			itemStyle = 'style="padding-bottom:100%;"',
			itemImages = '',
			itemVendor = boostPFSTemplate.itemVendorHtml,
			itemSwatch = buildSwatch(data),
			itemReviews = boostPFSTemplate.itemReviewsHtml;

		// gridMobileClass
		if (boostPFSConfig.custom.hasOwnProperty('grid_mobile')) {
			gridMobileClass = boostPFSConfig.custom.grid_mobile
		}
		itemHtml = itemHtml.replace(/{{grid_mobile}}/g, gridMobileClass);

		// gridItemWidthClass
		if (boostPFSConfig.custom.hasOwnProperty('grid_item_width')) {
			gridItemWidthClass = boostPFSConfig.custom.grid_item_width
		}
		itemHtml = itemHtml.replace(/{{grid_item_width}}/g, gridItemWidthClass);

		// itemGridDetailStyleClass
		if (boostPFSConfig.custom.hasOwnProperty('product_grid_detail_style') &&
			boostPFSConfig.custom.product_grid_detail_style == 'hover') {
			itemGridDetailStyleClass = 'product-card--details-hover';
		}
		itemHtml = itemHtml.replace(/{{itemGridDetailStyleClass}}/g, itemGridDetailStyleClass);

		// itemSoldOutClass
		if (soldOut) {
			itemSoldOutClass = 'product-card--sold-out';
		}
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// itemSaleClass
		if (onSale) {
			itemSaleClass = 'product-card--sale';
		}
		itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, itemSaleClass);

		// itemGridImageSizeClass
		itemHtml = itemHtml.replace(/{{itemGridImageSizeClass}}/g, itemGridImageSizeClass);

		// itemGridAlignClass
		if (boostPFSConfig.custom.hasOwnProperty('product_grid_align')) {
			itemGridAlignClass = boostPFSConfig.custom.product_grid_align;
		}
		itemHtml = itemHtml.replace(/{{itemGridAlignClass}}/g, itemGridAlignClass);


		// itemLabels
		var customLabel = false;
		var newLabel = false;

		if (boostPFSConfig.custom.hasOwnProperty('product_grid_label') &&
			boostPFSConfig.custom.product_grid_label) {
			// custom label
			if (boostPFSConfig.custom.product_grid_label_collection != '' && data.collections.length > 0) {
				for (var i = 0; i < data.collections.length; i++) {
					if (data.collections[i]['handle'] == boostPFSConfig.custom.product_grid_label_collection) {
						customLabel = true;
						break;
					}
				}
			}

			// new label
			var dateNow = boostPFSConfig.custom.date_now;
			var dateCreatedAt = Date.parse(data.created_at) / 1000;
			var timeAgo = (dateNow - dateCreatedAt) / 86400;
			if (timeAgo < boostPFSConfig.custom.product_grid_label_new_days) {
				newLabel = true;
			}

			if (soldOut) {
				itemLabels += boostPFSTemplate.soldOutLabelHtml;
			} else if (customLabel) {
				itemLabels += boostPFSTemplate.customLabelHtml;
			} else if (onSale) {
				itemLabels += boostPFSTemplate.saleLabelHtml.replace(/{{itemSalePercent}}/, data.percent_sale_min);
			} else if (newLabel &&
				boostPFSConfig.custom.hasOwnProperty('product_grid_label_new') &&
				boostPFSConfig.custom.product_grid_label_new) {
				itemLabels += boostPFSTemplate.newLabelHtml;
			}
		}
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabels);

		// itemGridSecondHoverClass
		if (boostPFSConfig.custom.hasOwnProperty('product_grid_second_hover') &&
			boostPFSConfig.custom.product_grid_second_hover == true &&
			images.length > 1) {
			itemGridSecondHoverClass = 'product-card__media--hover';
		}
		itemHtml = itemHtml.replace(/{{itemGridSecondHoverClass}}/g, itemGridSecondHoverClass);

		// itemRatio
		itemHtml = itemHtml.replace(/{{itemRatio}}/g, itemRatio);

		// itemStyle
		if (images.length > 0) {
			itemStyle = 'style="padding-bottom:' + Math.round(images[0].height / images[0].width * 100) + '%;"';
		}
		itemHtml = itemHtml.replace(/{{itemStyle}}/g, itemStyle);

		// Add itemImages
		var imageSrc = images.length > 0 ? images[0].src : boostPFSConfig.general.no_image_url;
		var imageRange = [180, 360, 540, 720, 900, 1080, 1296, 1512];
		var imageHoverSrcSet = '';

		var imageSrcSet = '';
		var imageAspectRatio = images.length > 0 ? images[0].width / images[0].height : 1;
		var imageHoverAspectRatio = images.length > 1 ? images[1].width / images[1].height : 1;

		for (var i = 0; i < imageRange.length; i++) {
			imageSrcSet += Utils.optimizeImage(imageSrc, imageRange[i] + 'x') + ' ' + imageRange[i] + 'w ' + Math.round(imageRange[i] / imageAspectRatio) + 'h';
			if (images.length > 1) {
				imageHoverSrcSet += Utils.optimizeImage(images[1]['src'], imageRange[i] + 'x') + ' ' + imageRange[i] + 'w ' + Math.round(imageRange[i] / imageHoverAspectRatio) + 'h';
			}

			if (i < imageRange.length - 1) {
				imageSrcSet += ', ';
				if (images.length > 1) {
					imageHoverSrcSet += ', ';
				}
			}
		}

		if (boostPFSConfig.custom.hasOwnProperty('product_grid_second_hover') &&
			boostPFSConfig.custom.product_grid_second_hover == true &&
			images.length > 1) {
			itemImages += '<img class="product-card__img-hover" ' +
				'src="' + Utils.optimizeImage(images[1].src, "300x") + '" ' +
				'srcset="' + imageHoverSrcSet + '" ' +
				'sizes="' + boostPFSConfig.custom.image_sizes + '" ' +
				'width="300" ' +
				'height="' + Math.round(300 / imageHoverAspectRatio) + '" ' +
				'alt="{{itemTitle}}" ' +
				'loading="lazy" />';
		}

		itemImages += '<img class="product-card__img" ' +
			'src="' + Utils.optimizeImage(imageSrc, "300x") + '" ' +
			'srcset="' + imageSrcSet + '" ' +
			'sizes="' + boostPFSConfig.custom.image_sizes + '" ' +
			'width="300" ' +
			'height="' + Math.round(300 / imageAspectRatio) + '" ' +
			'alt="{{itemTitle}}" ' +
			'loading="lazy" />';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

		// itemQuickBuy
		var itemQuickBuy = '';
		if (boostPFSConfig.custom.product_grid_quick_buy != 'disabled') {
			itemQuickBuy += '<div class="product-card-btn product-card-btn--' + boostPFSConfig.custom.product_grid_quick_buy + '">';
			if (soldOut) {
				itemQuickBuy += '<a href="{{itemUrl}}" class="c-btn c-btn--full c-btn--light c-btn--small-tab product-card-btn__btn">' + boostPFSConfig.label.sold_out + '</a>';
			} else if (data.variants.length > 1) {
				itemQuickBuy += '<a href="{{itemUrl}}" class="c-btn c-btn--full c-btn--primary c-btn--arrow c-btn--small-tab product-card-btn__btn">' + boostPFSConfig.label.select_options + '</a>';
			} else {
				itemQuickBuy += '<form method="post" action="/cart/add" id="product_form_{{itemId}}" accept-charset="UTF-8" class="js-product-form" enctype="multipart/form-data">';
				itemQuickBuy += '<input type="hidden" name="form_type" value="product">';
				itemQuickBuy += '<input type="hidden" name="utf8" value="✓">';
				itemQuickBuy += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
				itemQuickBuy += '<button type="submit" name="add" class="c-btn c-btn--full c-btn--primary c-btn--small-tab product-card-btn__btn js-product-add">';
				itemQuickBuy += '<span class="product-card-btn__text"><span class="js-product-add-text">' + boostPFSConfig.label.add_to_cart + '</span></span><span class="product-card-btn__tick"><i class="icon icon--tick"></i></span>';
				itemQuickBuy += '</button>';
				itemQuickBuy += '</form>';
			}
			itemQuickBuy += '</div>';
		}
		itemHtml = itemHtml.replace(/{{itemQuickBuy}}/g, itemQuickBuy);


		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

		// itemPrice
		var itemPrice = '';
		if (boostPFSConfig.custom.product_grid_price) {
			itemPrice += '<p class="product-card__price h5">';
			if (!soldOut) {
				if (onSale) {
					if (priceVaries) {
						itemPrice += '<span class="product-card__price-price"><span class="money">' + Utils.formatMoney(data.price_min) + '</span></span>';
						itemPrice += '<strike class="product-card__price-cross"><span class="money">' + Utils.formatMoney(data.compare_at_price_min) + '</span></strike>';
					} else {
						itemPrice += '<span class="product-card__price-price"><span class="money">' + Utils.formatMoney(data.price_min) + '</span></span>';
						itemPrice += '<strike class="product-card__price-cross"><span class="money">' + Utils.formatMoney(data.compare_at_price_min) + '</span></strike>';
					}
				} else {
					itemPrice += '<span class="product-card__price-price"><span class="money">' + Utils.formatMoney(data.price_min) + '</span></span>';
				}
			} else {
				itemPrice += '<span class="product-card__price-price product-card__price-price--sold">' + boostPFSConfig.label.sold_out + '</span>';
			}
			itemPrice += '</p>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPrice);

		// itemSwatch
		itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatch);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
		}
		itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	};

	function buildSwatch(data) {
		var html = '';
		var swatchItems = [];
		if (boostPFSConfig.custom.product_grid_swatch) {
			var colorKeys = ['color', 'colour'];
			var colorValues = [];
			data.variants.forEach(function(variant) {
				var colorValue = null;
				variant.merged_options.forEach(function(merged_option) {
					var key = merged_option.split(':')[0].toLowerCase();
					var value = merged_option.split(':')[1].toLowerCase();
					if (colorKeys.indexOf(key) != -1 && colorValues.indexOf(value) == -1) {
						colorValues.push(value);
						colorValue = value;
					}
				})
				if (colorValue) {
					var slugifyColor = Utils.slugify(colorValue);
					var backgroundImage = boostPFSAppConfig.general.asset_url.replace(/boost-pfs.js/, slugifyColor + '_68x' + '.png');
					var backgroundColor = slugifyColor.replace('-', '');

					var swatchItem = '<li class="product-card__swatch__item js-product-swatch-item o-list-inline__item" ' +
						'data-variant-image="{{variantImage}}" ' +
						'data-variant-url="{{variantUrl}}">' +
						'<span class="product-card__swatch__graphic {{whiteBorderClass}}" ' +
						'style="background-color: {{backgroundColor}}; ' +
						'background-image: url({{backgroundImage}})">' +
						'</span>' +
						'<span class="u-hidden-visually">{{colorValue}}</span>' +
						'</li>';
					swatchItem = swatchItem.replace(/{{variantImage}}/g, variant.image ? variant.image : data.images_info[0].src);
					swatchItem = swatchItem.replace(/{{variantUrl}}/g, '{{itemUrl}}?variant=' + variant.id);
					swatchItem = swatchItem.replace(/{{whiteBorderClass}}/g, colorValue.toLowerCase().trim() == 'white' ? 'product-card__swatch__graphic--white' : '');
					swatchItem = swatchItem.replace(/{{backgroundColor}}/g, backgroundColor);
					swatchItem = swatchItem.replace(/{{backgroundImage}}/g, backgroundImage);
					swatchItem = swatchItem.replace(/{{colorValue}}/g, colorValue);
					swatchItems.push(swatchItem);
				}
			});
			if (swatchItems.length > 0) {
				html = '<div class="product-card__swatch"><ul class="product-card__swatch__items o-list-inline">' + swatchItems.join(' ') + '</ul></div>';
			}
		}
		return html;
	}

	/************************** END BUILD PRODUCT LIST **************************/

	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;

		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	/************************** BUILD TOOLBAR **************************/

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {

			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
				return html;
			}
		}
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data, eventType) {};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		// Build filter button text
		var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
		if (numSelectedFilter) {
			jQ('.js-collection-draw-trigger').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
		} else {
			jQ('.js-collection-draw-trigger').html(boostPFSConfig.label.filter);
		}

		if (window.SPR) {
			SPR.initDomEls();
			SPR.loadBadges();
		}

		// Call theme function
		if (window.sr && typeof window.sr.reveal == 'function') {
			sr.reveal('.product-card-top');
		}
		if (window.theme) {
			if (typeof window.theme.selectWrapper == 'function') theme.selectWrapper();
			if (typeof window.theme.ajaxCartInit == 'function') theme.ajaxCartInit();
			if (typeof window.theme.productCollSwatch == 'function') theme.productCollSwatch();
		}
	};

	function reinitScrollbar() {
		// Re-init scrollbar in filter
		if (typeof SimpleBar == 'function') {
			jQ('[data-simplebar]').each(function(i, element) {
				var simpleBar = new SimpleBar(element);
				simpleBar.recalculate();
			})
		}
	}

	jQ('.js-collection-draw-trigger').on('click', function() {
		setTimeout(reinitScrollbar, 500);
	});
})();